import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-md border border-[var(--fop-border-2)] bg-[var(--fop-surface)] px-4 py-2 text-base text-[var(--fop-text)] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--fop-text)] placeholder:text-[var(--fop-text-3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fop-primary)] focus-visible:border-[var(--fop-primary)] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
